import {
  getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationFetcher,
  getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation202 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

/**
 * アクティベーションコード一括作成APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param clientId - 利用企業ID
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostBulkActivationCodeCreation = (
  threeLetterCode: string,
  clientId: number,
  options?: {
    onSuccess?: (
      data: PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreation202
    ) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationKey(
      threeLetterCode,
      clientId
    ),
    getPostApiV1ThreeLetterCodePartnerAdminsClientsClientIdBulkActivationCodeCreationMutationFetcher(
      threeLetterCode,
      clientId
    ),
    options
  );
};
